import { useTranslation } from 'react-i18next';
import { Education } from '../../../../../../types/psychometric';
import EducationItem from './EducationItem';

interface EducationSectionProps {
  education: Education[];
}

export function EducationSection({ education }: EducationSectionProps) {
  const { t } = useTranslation();
  if (!education?.length) return null;

  return (
    <div className="tc-mv-question-field p-4 rounded-2xl text-white space-y-2">
      <h2 className="text-xl font-semibold">{t('profile.education')}</h2>
      <div className="space-y-8">
        {education.map((edu, index) => (
          <EducationItem key={index} education={edu} />
        ))}
      </div>
    </div>
  );
}
